import { FormattedMessage } from 'react-intl';
import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

const textStyle = {
  wordBreak: 'break-word'
};

function GenericPopup({ genericPopupKey, genericPopupText, genericPopupDefault }) {
  return (
    <div
      className={classnames(
        'pt-15',
        'pl-20',
        'pr-20',
        'pb-dt-35',
        'pb-xs-25',
        'text-center'
      )}
    >
      <p className="mt-xs-25 mt-dt-35 f-16">
        {genericPopupKey ? (
          <FormattedMessage
            id={genericPopupKey}
            defaultMessage={genericPopupDefault || undefined}
          />
        ) : (
          <span style={textStyle}>{genericPopupText}</span>
        )}
      </p>
    </div>
  );
}

function mapStateToProps(state) {
  const { genericPopupKey, genericPopupText, genericPopupDefault } = state.popup;

  return { genericPopupKey, genericPopupText, genericPopupDefault };
}

export default connect(mapStateToProps)(GenericPopup);
